import * as React from "react";

export function Card({ className = "", ...props }) {
  return (
    <div
      className={`rounded-2xl border border-gray-200 bg-white shadow-sm ${className}`}
      {...props}
    />
  );
}

export function CardHeader({ className = "", ...props }) {
  return (
    <div
      className={`border-b px-4 py-3 font-semibold text-gray-900 ${className}`}
      {...props}
    />
  );
}

export function CardContent({ className = "", ...props }) {
  return (
    <div className={`px-4 py-4 text-gray-700 ${className}`} {...props} />
  );
}

export function CardFooter({ className = "", ...props }) {
  return (
    <div
      className={`border-t px-4 py-3 text-sm text-gray-600 ${className}`}
      {...props}
    />
  );
}
